import { PAYMENT_METHODS, PAYMENT_LABELS } from '../../utils/constants';
import { formatPrice } from '../../utils/helpers';
import './PaymentMethod.css';

const ALL_METHODS = [
  PAYMENT_METHODS.ESEWA,
  PAYMENT_METHODS.KHALTI,
  PAYMENT_METHODS.CASH_ON_DELIVERY,
];

const PaymentMethod = ({ selectedMethod, onSelect, codSurcharge = 0 }) => {
  return (
    <div className="payment-method">
      <h3>Payment Method</h3>
      <div className="payment-options">
        {ALL_METHODS.map((method) => {
          const isCod = method === PAYMENT_METHODS.CASH_ON_DELIVERY;
          const showSurcharge = isCod && codSurcharge > 0;
          return (
            <label
              key={method}
              className={`payment-option ${selectedMethod === method ? 'selected' : ''}`}
            >
              <input
                type="radio"
                name="paymentMethod"
                value={method}
                checked={selectedMethod === method}
                onChange={(e) => onSelect(e.target.value)}
              />
              <div className="payment-option-content">
                <span>{PAYMENT_LABELS[method]}</span>
                {showSurcharge && (
                  <span className="payment-cod-surcharge">
                    +{formatPrice(codSurcharge)} COD fee
                  </span>
                )}
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethod;
